import { render } from "./average-response-time-of-methods.vue?vue&type=template&id=6050c690"
import script from "./average-response-time-of-methods.vue?vue&type=script&lang=ts"
export * from "./average-response-time-of-methods.vue?vue&type=script&lang=ts"

import "./average-response-time-of-methods.vue?vue&type=style&index=0&id=6050c690&lang=less"
script.render = render

export default script